import React from 'react';
import Head from 'next/head';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
// import Tabs from '@mui/material/Tabs';
// import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

import Layout from '../components/layout';

type Props = {};

type State = {
  value: number;
  checked: boolean;
};

// interface TabPanelProps {
//   children?: React.ReactNode;
//   index: number;
//   value: number;
// }

// function CustomTabPanel(props: TabPanelProps) {
//   const { children, value, index, ...other } = props;
//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`simple-tabpanel-${index}`}
//       aria-labelledby={`simple-tab-${index}`}
//       {...other}
//     >
//       {value === index && (
//         <Box sx={{ p: 3 }}>
//           <Typography>{children}</Typography>
//         </Box>
//       )}
//     </div>
//   );
// }

// function a11yProps(index: number) {
//   return {
//     id: `simple-tab-${index}`,
//     'aria-controls': `simple-tabpanel-${index}`,
//   };
// }

class AICruiterPage extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = { value: 0, checked: false };
  }

  public handleChange = (_: React.SyntheticEvent, newValue: number) => {
    this.setState({ value: newValue });
  };

  // public zoom = () => {
  //   this.setState({ checked: true });
  // };

  public render() {
    return (
      <Layout {...this.props}>
        <div style={{ width: '100%' }}>
          <Head>
            <title>Harbor ATS/CRM</title>
            <meta name="description" content="All-in-one platform for recruiting agencies." />
            <meta name="robots" content="index, follow" />
          </Head>
          <Box
            sx={{
              padding: { xs: '0px 10%', md: '0px 20%' },
              marginBottom: '100px',
            }}
          >
            <Grid container direction="row" justifyContent="space-around" alignItems="flex-start">
              <Grid item sm={12} xs={12}>
                <h1
                  style={{
                    marginTop: '50px',
                    marginBottom: '-10px',
                  }}
                >
                  Harbor ATS/CRM: All-in-one platform for recruiting agencies
                </h1>
                <p>
                  Harbor combines an ATS for candidate management, a CRM for client relationships and business
                  development, AI tools for faster candidate reviews and personalized communications, plus advanced
                  features like booking links, email sequences, and candidate search to enhance productivity of your
                  recruiting team.
                </p>

                <div style={{ textAlign: 'center', margin: '40px 20px 20px 20px' }}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      window.open(`https://talenttrackr.com`);
                    }}
                  >
                    Learn more about Harbor ATS/CRM
                  </Button>
                </div>

                <hr style={{ width: '100%', margin: '40px auto 0px auto' }} />
              </Grid>

              <video
                controls
                style={{ width: '100%', height: 'auto', marginTop: 40 }}
                poster="https://d28ag32sldh69i.cloudfront.net/resources/vlcsnap-2025-01-06-11h34m09s939.png"
              >
                <source src="https://d28ag32sldh69i.cloudfront.net/resources/tt-jan-2025.mp4" type="video/mp4" />
              </video>
            </Grid>
          </Box>
        </div>
      </Layout>
    );
  }
}

export default AICruiterPage;
